import React from 'react';
import './Body.css';
import RouterOutlet from '../../Routes';
// import RouterOutlets from '../../Routes1';

const Body = ({
  landing_page = "BenchmarkNow"
}) => {
  return (
    <div className="app-body" id="app-body">
      <RouterOutlet landing_page = {landing_page}/>
    </div>
  );
};

export default Body;
